// extracted by mini-css-extract-plugin
export default {"lead__Approval__View":"styles_lead__Approval__View__LgsQc","back__Btn__Wrap":"styles_back__Btn__Wrap__sQ0KN","back__Btn":"styles_back__Btn__PLfWY"};